const addToBasket = function(basketItem, i) {
    const item = basketItem[i]
    const count = item?.plugins?.basket.count ?? 1;

    if (item && item.id) {
        const splitId = item.id.split(":");
        const productId = splitId[0];
        const variantId = splitId[1];
        const data = new URLSearchParams();
        data.append("amount", count);
        data.append("attributes[30385]", variantId);
        data.append("product_id", productId);

        fetch(item.link, {
            method: 'post',
            body: data,
        }).then(() => {
            if(i < basketItem.length-1) {
                addToBasket(basketItem, i+1);
            } else {
                window.location.reload();
            }
        })
    }
};
  

window.catalogueAddToBasket = function (basketItem) {
    addToBasket(basketItem, 0)
}
